/* eslint-disable no-shadow */
export enum HostingsQueryKeys {
  GetAll = 'hostings/getAll',
  GetOneById = 'hostings/getById',
  Create = 'hostings/create',
  Edit = 'hostings/edit',
  Delete = 'hostings/delete',
  Autocomplete = 'hostings/autocomplete',
  Breadcrumb = 'hostings/breadcrumb',
}

export enum HostingAccountsQueryKeys {
  GetAll = 'hostingAccounts/getAll',
  ShowPassword = 'hostingAccounts/showPassword',
  Create = 'hostingAccounts/create',
  Edit = 'hostingAccounts/edit',
  Delete = 'hostingAccounts/delete',
  Autocomplete = 'hostingAccounts/autocomplete',
}
